import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { ExistingCatalogSchemasField } from './ExistingCatalogSchemasField';

export const ExistingCatalogSchemasFieldExtension = FormFieldBlueprint.make({
  name: 'existing-catalog-schemas-field',
  params: {
    field: async () =>
      createFormField({
        name: 'ExistingCatalogSchemasField',
        component: ExistingCatalogSchemasField,
      }),
  },
});
